import { intelligentPhotoCaptureConstants } from '../constants';
export const INTELLIGENT_PHOTO_CAPTURE_CREATE_ATTACHMENT_BATCH_ACTIVITY_INFO = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_CREATE_ATTACHMENT_BATCH_ACTIVITY_INFO`;
export const INTELLIGENT_PHOTO_CAPTURE_UPDATE_BATCH_STATUS = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_UPDATE_BATCH_STATUS`;
export const photoCaptureIntelligentCreateAttachmentBatchActivityInfoAction = (batchId, files) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_CREATE_ATTACHMENT_BATCH_ACTIVITY_INFO,
    payload: { batchId, files }
});
export const photoCaptureIntelligentUpdateBatchStatusAction = (batchId) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_UPDATE_BATCH_STATUS,
    payload: { batchId }
});
//# sourceMappingURL=photoCaptureIntelligentAttachmentBatchActivityInfoAction.js.map